import styled from 'styled-components';
import React, {FC} from 'react';

import {fontFamiliesStrings, fontSizesMixins, fontWeights, palette} from '../../lib/styleVariables';

interface TitleProps {
  className?: string;
}

const titleCommonStyle = `
  font-family: ${fontFamiliesStrings.title};
  font-style: normal;
  font-weight: ${fontWeights.medium};
  color: ${palette.black.base};
`;
const StyledSectionTitleH1 = styled.h1`
  ${titleCommonStyle}
  ${fontSizesMixins.h0()}
`;

export const HeroTitle: FC<TitleProps> = props => (
  <StyledSectionTitleH1 {...props}>{props.children}</StyledSectionTitleH1>
);

const StyledSectionTitleH2 = styled.h2`
  ${titleCommonStyle}
  ${fontSizesMixins.h1()}
`;

export const SubHeroTitle: FC<TitleProps> = props => (
  <StyledSectionTitleH2 {...props}>{props.children}</StyledSectionTitleH2>
);

const StyledSectionTitleH3 = styled.h3`
  ${titleCommonStyle}
  ${fontSizesMixins.h2()}
  font-weight: ${fontWeights.normal};
`;

export const SectionTitle: FC<TitleProps> = props => (
  <StyledSectionTitleH3 {...props}>{props.children}</StyledSectionTitleH3>
);

const StyledSubSectionTitleH4 = styled.h4`
${titleCommonStyle}
${fontSizesMixins.h3()}
font-weight: ${fontWeights.normal};
`;

export const SubSectionTitle: FC<TitleProps> = props => (
  <StyledSubSectionTitleH4 {...props}>{props.children}</StyledSubSectionTitleH4>
);

const StyledEyebrowTitleSpan = styled.span`
  ${titleCommonStyle}
  ${fontSizesMixins.text3()}
`;

export const EyebrowTitle: FC<TitleProps> = props => (
  <StyledEyebrowTitleSpan {...props}>{props.children}</StyledEyebrowTitleSpan>
);

const StyledEyebrowCardTitleSpan = styled(StyledEyebrowTitleSpan)`
  ${titleCommonStyle}
  ${fontSizesMixins.text4()}
`;

export const EyebrowCardTitle: FC<TitleProps> = props => (
  <StyledEyebrowCardTitleSpan {...props}>{props.children}</StyledEyebrowCardTitleSpan>
);

const StyledTextBlockSpan = styled.span<{$fontSizeCss: string}>`
  ${titleCommonStyle}
  ${props => props.$fontSizeCss}
`;

export const TextBlock1: FC<TitleProps> = props => (
  <StyledTextBlockSpan {...props} $fontSizeCss={fontSizesMixins.text1()}>
    {props.children}
  </StyledTextBlockSpan>
);

export const TextBlock2: FC<TitleProps> = props => (
  <StyledTextBlockSpan {...props} $fontSizeCss={fontSizesMixins.text2()}>
    {props.children}
  </StyledTextBlockSpan>
);

export const TextBlock2Spread: FC<TitleProps> = props => (
  <StyledTextBlockSpan {...props} $fontSizeCss={fontSizesMixins.text2Spread()}>
    {props.children}
  </StyledTextBlockSpan>
);

export const TextBlock3: FC<TitleProps> = props => (
  <StyledTextBlockSpan {...props} $fontSizeCss={fontSizesMixins.text3()}>
    {props.children}
  </StyledTextBlockSpan>
);
